export type PaginationParams = { page: number; limit: number; search?: string; sort?: string }

export const DEFAULT_PAGINATION_PARAMS: PaginationParams = {
  page: 1,
  limit: 50,
}

export interface PaginationMetadata {
  currentPage: number
  isFirstPage: boolean
  isLastPage: boolean
  nextPage: number | undefined
  pageCount: number | undefined
  previousPage: number | undefined
  totalCount: number | undefined
  selected: number | undefined
}
